import { useRef } from 'react';
import HeroBanner from "../../base/HeroBanner/HeroBanner";
import TopicIntro from "../../base/Topic/TopicIntro";
import SinglePage from "../SinglePage/SinglePage";
import { Container } from "./styles";
import { smoothScrollTo } from "../../functionallity/smoothScrollTo";
import HorizontalLinearStepper from './Stepper/HorizontalLinearStepper';


const Application = () => {
    const topicIntroRef = useRef<HTMLDivElement>(null);

    const scrollToTopicIntro = () => {
        if (topicIntroRef.current) {
            smoothScrollTo(topicIntroRef.current, 2000);
        }
    };

    return (
        <SinglePage
            title='Bewerbung'
            heroBanner={
                <HeroBanner
                    imageSource={require('../../../assets/images/Application/silhouetteWitchApplying.png')}
                    headline="BEWERBUNG."
                    text="Bist du bereit eine Eckenmoorhexe zu sein? Dann befolge die Schritte."
                    onNextSection={scrollToTopicIntro}
                />
            }
            topic={
                <div ref={topicIntroRef}>
                    <TopicIntro
                        headline="BEWERBUNG."
                        introductionText="Du möchtest Teil der Eckenmoorhexen werden? Wir freuen uns über dein Interesse! Um den Bewerbungsprozess für dich so einfach wie möglich zu gestalten, haben wir die Schritte übersichtlich für dich zusammengefasst. Folge den Anweisungen Schritt für Schritt, um dich erfolgreich bei uns zu bewerben. Wir sind gespannt darauf, dich kennenzulernen und vielleicht schon bald als neues Mitglied in unserer Gemeinschaft willkommen zu heißen!"
                    />
                </div>
            }
            content={
                <Container>
                    <HorizontalLinearStepper />
                </Container>
            }
        />
    );
}

export default Application;
